import { useUserPrefs } from '@/context/UserPrefsContext'
import { Switch } from '@heroui/react'

export default function PermissionsCheck() {
  const { userPrefs, setGyroPermission } = useUserPrefs()

  // Only show switch if DeviceOrientationEvent exists (gyro-capable or iOS/Safari)
  if (typeof window === 'undefined' || !('DeviceOrientationEvent' in window)) return null

  if (!userPrefs.isMobile || !userPrefs.hasGyro) return null

  const handleMotionSwitch = async (checked: boolean) => {
    await setGyroPermission(checked)
  }

  return (
    <div style={{ marginBottom: '2rem' }}>
      <Switch isSelected={userPrefs.useGyro} onValueChange={handleMotionSwitch} className="ml-0">
        Enable Motion Controls
      </Switch>
    </div>
  )
}
